import { type Loadable } from '@/loadingUtils'
import type { Teach } from '@pocketprep/types'

export type TIntegrationsModuleState = {
    integrations: { [organizationId: string]: Loadable<Teach.Class.LMSJSON[]> | undefined }
    courseIntegrations: { [organizationId: string]: Loadable<Teach.Class.LMSCourseIntegrationJSON[]> | undefined }
}

export const getInitialIntegrationsState = (): TIntegrationsModuleState => {
    return {
        integrations: {},
        courseIntegrations: {},
    }
}

const moduleState = getInitialIntegrationsState()

export default moduleState
